import axios from "axios";

export const downloadPackageHistoryReport = async (registrationIds: (string | undefined)[]) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/downloadPackageHistoryReport`,
      {
        keys: registrationIds,
      },
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );

    return response;
  } catch (err: any) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error("An unexpected error occurred");
    }
  }
};
